export default __webpack_public_path__ + "static/KFZapp_3-c55bb87e6bc4b9452764e43f0eee0e21.png";